export default __webpack_public_path__ + "src/assets/ARTPOOL_ATHORIZATIONFORM_COPYRIGHT.6b95a683.pdf";